"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeFixedAddonWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var modals = require("./tierTable/TierTableInfoModalRenderers");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var SuggestionModal_1 = require("../../../components/modals/SuggestionModal");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../commonFunctions");
var OptionalExtrasQuestionWidgetBase_1 = require("../common/OptionalExtrasQuestionWidgetBase");
var AnnualHomeFixedAddonWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeFixedAddonWidget, _super);
    function AnnualHomeFixedAddonWidget(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (addonName, noThanks) {
            if (addonName === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
                _this.handleBuildingAccidentalDamage(noThanks);
            }
            else if (addonName === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
                _this.handleContentsAccidentalDamage(noThanks);
            }
            else if (addonName === services_1.HOME_LEGAL_EXPENSES) {
                _this.handleHomeLegalExpenses(noThanks);
            }
            else if (addonName === services_1.HOME_EMERGENCY) {
                _this.handleHomeEmergency(noThanks);
            }
            _this.validateInternal(addonName, false);
            _this.executeEvent("change");
        };
        var addons = _this.props.interaction.annualHomeFixedAddons;
        _this.state = {
            isSuggestionModalOpen: false,
            buildingsAccidentalDamageWasAddedOnce: !!(addons === null || addons === void 0 ? void 0 : addons.buildingAccidentalDamage),
            contentsAccidentalDamageWasAddedOnce: !!(addons === null || addons === void 0 ? void 0 : addons.contentsAccidentalDamage),
            homeLegalExpensesWasAddedOnce: !!(addons === null || addons === void 0 ? void 0 : addons.homeLegalExpenses),
            homeEmergencyWasAddedOnce: !!(addons === null || addons === void 0 ? void 0 : addons.homeEmergency),
        };
        _this.toggleSuggestionModal = _this.toggleSuggestionModal.bind(_this);
        var policyStartDateAsString = (_b = (_a = _this.props.interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : _this.props.interaction.factors.originalQuoteDate;
        _this.policyStartDate = new Date(policyStartDateAsString);
        if (_this.getSetting("resetUnselectedAddons", false) && addons) {
            if (!addons.buildingAccidentalDamage) {
                addons.buildingAccidentalDamage = null;
            }
            if (!addons.contentsAccidentalDamage) {
                addons.contentsAccidentalDamage = null;
            }
            if (!addons.homeLegalExpenses) {
                addons.homeLegalExpenses = null;
            }
            if (!addons.homeEmergency) {
                addons.homeEmergency = null;
            }
        }
        return _this;
    }
    AnnualHomeFixedAddonWidget.prototype.render = function () {
        var _a, _b, _c, _d;
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var showTierWarning = this.getSetting("showTierWarning", true);
        var buildingAccidentalDamage = {
            name: services_1.BUILDING_ACCIDENTAL_DAMAGE,
            wording: "Enhanced Buildings Accidental Damage",
            image: "buildings-accidental-damage.png",
            modalHeader: "Enhanced Buildings Accidental Damage",
            showAmount: false
        };
        var contentsAccidentalDamage = {
            name: services_1.CONTENTS_ACCIDENTAL_DAMAGE,
            wording: "Enhanced Contents Accidental Damage",
            image: "contents-accidental-damage.png",
            modalHeader: "Enhanced Contents Accidental Damage",
            showAmount: false
        };
        var homeLegalExpenses = {
            name: services_1.HOME_LEGAL_EXPENSES,
            wording: "Home Legal Expenses",
            image: "homeLegal-expenses.png",
            amount: isMonthly ? (_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.monthlyLegalExpensesPremium : (_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.annualLegalExpensesPremium,
            modalHeader: "Home Legal Expenses",
            showAmount: true
        };
        var homeEmergency = {
            name: services_1.HOME_EMERGENCY,
            wording: "Home Emergency",
            image: "home-emergency.png",
            amount: isMonthly ? (_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.monthlyHomeEmergencyPremium : (_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.annualHomeEmergencyPremium,
            modalHeader: "Home Emergency",
            showAmount: true
        };
        var isPremier = this.props.interaction.coverTier === services_1.GOLD_TIER;
        var goldTierEligible = (0, commonFunctions_1.isTierNotDeclined)(services_1.GOLD_TIER, this.props.interaction.tieredUnderwritingResult);
        var isContentsOnlyCover = (0, commonFunctions_1.isCoverLevelContentsOnly)(this.props.interaction.coverLevel);
        var isBuildingsOnlyCover = (0, commonFunctions_1.isCoverLevelBuildingsOnly)(this.props.interaction.coverLevel);
        var realEstate = this.props.interaction.realEstate[0];
        var isOwned = (0, commonFunctions_1.isPropertyOwned)(realEstate.ownershipType);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isContentsOnlyCover && this.renderAddon(buildingAccidentalDamage), !isBuildingsOnlyCover && this.renderAddon(contentsAccidentalDamage), this.renderAddon(homeLegalExpenses), isOwned && this.renderAddon(homeEmergency), isOwned && goldTierEligible && showTierWarning && this.props.interaction.process === services_1.INTERACTION_PROCESS_NB && !isPremier && this.state.isSuggestionModalOpen && this.renderSuggestionModal()] }));
    };
    AnnualHomeFixedAddonWidget.prototype.getAddonValues = function (addonName) {
        if (addonName === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
            return this.getBuildingAccidentalDamageValues();
        }
        else if (addonName === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
            return this.getContentsAccidentalDamageValues();
        }
        else if (addonName === services_1.HOME_LEGAL_EXPENSES) {
            return this.getHomeLegalExpensesValues();
        }
        else if (addonName === services_1.HOME_EMERGENCY) {
            return this.getHomeEmergencyValues();
        }
        return { valueNotSelected: false, addonIsAdded: false, selected: false };
    };
    AnnualHomeFixedAddonWidget.prototype.renderAddon = function (addon) {
        var _this = this;
        var _a, _b;
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var isPremier = this.props.interaction.coverTier === services_1.GOLD_TIER;
        var isAllianz = services_1.resourcesHelper.THEME === "Allianz";
        var addonValues = this.getAddonValues(addon.name);
        var valueNotSelected = addonValues.valueNotSelected;
        var addonIsAdded = addonValues.addonIsAdded;
        var selected = addonValues.selected;
        if (isPremier) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-background-selected quote row mt-2 pb-0", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col p-0 d-flex align-items-start fixed-addon-item", children: [(0, jsx_runtime_1.jsx)("img", { className: "fixed-addon-icon float-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" }), (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "heading-info", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold mb-0 heading", children: addon.wording }), isAllianz && (0, jsx_runtime_1.jsx)("button", { className: "fixed-addon-info", children: this.renderModal(addon) })] }), (0, jsx_runtime_1.jsx)("p", { className: "mt-0 mb-0", children: "Included as standard" })] })] }), !isAllianz && (0, jsx_runtime_1.jsx)("div", { className: "fixed-addon-info", children: this.renderModal(addon) })] }));
        }
        else {
            var validationErrors = (0, commonFunctions_1.getValidationErrors)(this.props, addon.name);
            var hasValidationErrors = ((_a = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) !== null && _a !== void 0 ? _a : 0) > 0;
            return ((0, jsx_runtime_1.jsxs)("div", { id: addon.name, className: "".concat(selected ? "fixed-addon-background-selected quote row mt-2 pb-0" : "fixed-addon-background quote row mt-2 pb-0", " ").concat(hasValidationErrors ? "is-invalid" : ""), children: [(0, jsx_runtime_1.jsxs)("div", { className: "col p-0 fixed-addon-item", children: [(0, jsx_runtime_1.jsx)("img", { className: "fixed-addon-icon flex-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(addon.image), alt: "addon icon" }), (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "heading-info", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold mb-0 heading", children: addon.wording }), isAllianz && (0, jsx_runtime_1.jsx)("button", { className: "fixed-addon-info", children: this.renderModal(addon) })] }), this.renderAmountWordingFragment(selected, isMonthly, addon)] }), hasValidationErrors &&
                                (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: (_b = validationErrors[0]) === null || _b === void 0 ? void 0 : _b.errorMessage }), (0, jsx_runtime_1.jsx)("div", { className: "fixed-addon-buttons", children: (0, jsx_runtime_1.jsxs)("div", { className: "optional-extra-btn-container", children: [(0, jsx_runtime_1.jsx)("button", { onClick: function () { if (!selected) {
                                                _this.handleOnChangeEvent(addon.name);
                                            } }, className: "optional-extra-btn-no-items".concat(selected ? "--added" : ""), children: selected ? "Added" : "Add" }), valueNotSelected ? (0, jsx_runtime_1.jsx)("button", { onClick: function () { return _this.handleOnChangeEvent(addon.name, true); }, className: "optional-extra-btn-no-items", children: "No, thanks" }) :
                                            (0, jsx_runtime_1.jsx)("button", { onClick: function () { if (addonIsAdded) {
                                                    _this.handleOnChangeEvent(addon.name);
                                                } }, className: "optional-extra-btn", children: addonIsAdded ? "Remove" : "Not added" })] }) })] }), !isAllianz && (0, jsx_runtime_1.jsx)("div", { className: "fixed-addon-info", children: this.renderModal(addon) })] }));
        }
    };
    AnnualHomeFixedAddonWidget.prototype.getHomeEmergencyValues = function () {
        var _a, _b, _c, _d;
        var valueNotSelected = ((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.homeEmergency) == null;
        var addonIsAdded = ((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.homeEmergency) != null && ((_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.homeEmergency) !== false;
        var selected = ((_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.homeEmergency) || false;
        return { valueNotSelected: valueNotSelected, addonIsAdded: addonIsAdded, selected: selected };
    };
    AnnualHomeFixedAddonWidget.prototype.getHomeLegalExpensesValues = function () {
        var _a, _b, _c, _d;
        var valueNotSelected = ((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.homeLegalExpenses) == null;
        var addonIsAdded = ((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.homeLegalExpenses) != null && ((_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.homeLegalExpenses) !== false;
        var selected = ((_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.homeLegalExpenses) || false;
        return { valueNotSelected: valueNotSelected, addonIsAdded: addonIsAdded, selected: selected };
    };
    AnnualHomeFixedAddonWidget.prototype.getContentsAccidentalDamageValues = function () {
        var _a, _b, _c, _d;
        var valueNotSelected = ((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.contentsAccidentalDamage) == null;
        var addonIsAdded = ((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.contentsAccidentalDamage) != null && ((_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.contentsAccidentalDamage) !== false;
        var selected = ((_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.contentsAccidentalDamage) || false;
        return { valueNotSelected: valueNotSelected, addonIsAdded: addonIsAdded, selected: selected };
    };
    AnnualHomeFixedAddonWidget.prototype.getBuildingAccidentalDamageValues = function () {
        var _a, _b, _c, _d;
        var valueNotSelected = ((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.buildingAccidentalDamage) == null;
        var addonIsAdded = ((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage) !== null && ((_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.buildingAccidentalDamage) !== false;
        var selected = ((_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.buildingAccidentalDamage) || false;
        return { valueNotSelected: valueNotSelected, addonIsAdded: addonIsAdded, selected: selected };
    };
    AnnualHomeFixedAddonWidget.prototype.renderAmountWordingFragment = function (selected, isMonthly, addon) {
        if (addon.showAmount) {
            return ((0, jsx_runtime_1.jsxs)("p", { className: "mt-0 mb-0 addon-price-text", children: ["for", " ", (0, jsx_runtime_1.jsx)("span", { className: "addon-price", children: (0, commonFunctions_1.getAmountToDisplay)(addon.amount) }), isMonthly ? " / month" : " / year"] }));
        }
        else if (selected) {
            return ((0, jsx_runtime_1.jsx)("p", { className: "mt-0 mb-0", children: "Added" }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeFixedAddonWidget.prototype.handleHomeEmergency = function (noThanks) {
        var _a, _b;
        if (noThanks) {
            if (((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.homeEmergency) == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.homeEmergency", false, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", this.props.interaction, false);
        }
        else {
            var selected = !!((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.homeEmergency);
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.homeEmergency", !selected, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", this.props.interaction, !selected);
            this.handleGoldSuggestionModal(selected);
            if (!this.state.homeEmergencyWasAddedOnce) {
                this.setState({ homeEmergencyWasAddedOnce: true });
                this.toggleSuggestionModal();
            }
        }
    };
    AnnualHomeFixedAddonWidget.prototype.handleHomeLegalExpenses = function (noThanks) {
        var _a, _b, _c;
        if (noThanks) {
            if (((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.homeLegalExpenses) == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.homeLegalExpenses", false, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", this.props.interaction, false);
        }
        else {
            var selected = ((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.homeLegalExpenses) ? (_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.homeLegalExpenses : false;
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.homeLegalExpenses", !selected, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", this.props.interaction, !selected);
            this.handleGoldSuggestionModal(selected);
            if (!this.state.homeLegalExpensesWasAddedOnce) {
                this.setState({ homeLegalExpensesWasAddedOnce: true });
                this.toggleSuggestionModal();
            }
        }
    };
    AnnualHomeFixedAddonWidget.prototype.handleBuildingAccidentalDamage = function (noThanks) {
        var _a, _b;
        if (noThanks) {
            if (((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.buildingAccidentalDamage) == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.buildingAccidentalDamage", false, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", this.props.interaction, false);
        }
        else {
            var selected = !!((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage);
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.buildingAccidentalDamage", !selected, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", this.props.interaction, !selected);
            if (!this.state.buildingsAccidentalDamageWasAddedOnce) {
                this.setState({ buildingsAccidentalDamageWasAddedOnce: true });
                this.toggleSuggestionModal();
            }
        }
    };
    AnnualHomeFixedAddonWidget.prototype.handleContentsAccidentalDamage = function (noThanks) {
        var _a, _b;
        if (noThanks) {
            if (((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.contentsAccidentalDamage) == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.contentsAccidentalDamage", false, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", this.props.interaction, false);
        }
        else {
            var selected = !!((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.contentsAccidentalDamage);
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("annualHomeFixedAddons.contentsAccidentalDamage", !selected, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", this.props.interaction, !selected);
            if (!this.state.contentsAccidentalDamageWasAddedOnce) {
                this.setState({ contentsAccidentalDamageWasAddedOnce: true });
                this.toggleSuggestionModal();
            }
        }
    };
    AnnualHomeFixedAddonWidget.prototype.renderModal = function (addon) {
        return (0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon mt-3 white-bg", title: addon.modalHeader, children: this.renderModalBody(addon.name) });
    };
    AnnualHomeFixedAddonWidget.prototype.renderModalBody = function (addonName) {
        if (addonName === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
            return modals.renderBuildingsAccidentalDamageModal(this.policyStartDate);
        }
        else if (addonName === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
            return modals.renderContentsAccidentalDamageModal(this.policyStartDate);
        }
        else if (addonName === services_1.HOME_LEGAL_EXPENSES) {
            return modals.renderLegalExpensesModal();
        }
        else if (addonName === services_1.HOME_EMERGENCY) {
            return modals.renderHomeEmergencyModal();
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeFixedAddonWidget.prototype.renderSuggestionModal = function () {
        var modalTitle = "Because of the changes you've made...";
        return ((0, jsx_runtime_1.jsx)(SuggestionModal_1.SuggestionModal, { title: modalTitle, isSuggestionModalOpen: this.state.isSuggestionModalOpen, toggleSuggestionModal: this.toggleSuggestionModal, children: modals.renderFlowPremierSuggestionModal(this.props.interaction.coverLevel) }));
    };
    AnnualHomeFixedAddonWidget.prototype.toggleSuggestionModal = function () {
        this.setState(function (state) { return ({
            isSuggestionModalOpen: !state.isSuggestionModalOpen
        }); });
    };
    AnnualHomeFixedAddonWidget.prototype.handleGoldSuggestionModal = function (selected) {
        if (!selected && (!this.state.homeLegalExpensesWasAddedOnce || !this.state.homeEmergencyWasAddedOnce)) {
            journey_services_1.ObjectManipulator.setField("uistate.showGoldSuggestionModal", this.props.interaction, true);
        }
    };
    AnnualHomeFixedAddonWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showTierWarning", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "resetUnselectedAddons", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeFixedAddonWidget);
    return AnnualHomeFixedAddonWidget;
}(OptionalExtrasQuestionWidgetBase_1.OptionalExtrasQuestionWidgetBase));
exports.AnnualHomeFixedAddonWidget = AnnualHomeFixedAddonWidget;
//# sourceMappingURL=AnnualHomeFixedAddonWidget.js.map